/**
 * Team drawer → Profile: which fields actually changed.
 *
 * The drawer used to send name, role, timezone and active on every save, so every
 * edit was recorded as a role/access write. Role and active are portal access (only
 * a super admin may change them, PR #4227); now they're sent only when they change.
 */

export interface TeamProfileFields {
  full_name: string | null;
  role: string;
  timezone: string | null;
  active: boolean;
  slack_handle: string | null;
}

export function normalizeHandle(raw: string): string {
  return raw.trim().replace(/^@+/, '').toLowerCase();
}

export function profileChanges(orig: TeamProfileFields, draft: TeamProfileFields): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  const name = (draft.full_name ?? '').trim();
  if (name !== (orig.full_name ?? '')) out.full_name = name;
  if (draft.role !== orig.role) out.role = draft.role;
  const tz = (draft.timezone ?? '').trim();
  if (tz !== (orig.timezone ?? '')) out.timezone = tz || null;
  if (draft.active !== orig.active) out.active = draft.active;
  const handle = normalizeHandle(draft.slack_handle ?? '');
  if (handle !== (orig.slack_handle ?? '')) out.slack_handle = handle || null;
  return out;
}
